module.exports = __webpack_public_path__ + "img/pro_feature_currencies.7fd0577.png";